import React from 'react';
import lazyRetry from '../services/lazyRetry';
import Playground from './pages/Playground';

const Home = React.lazy(() => lazyRetry(() => import('./pages/Home')));
const HomeV2 = React.lazy(() => lazyRetry(() => import('./pages/HomeV2')));
const MySip = React.lazy(() => lazyRetry(() => import('./pages/MySip')));
const SipActivity = React.lazy(() => lazyRetry(() => import('./components/SipActivity')));
// const AllocateFunds = React.lazy(() => lazyRetry(() => import('./pages/AllocateFunds')));
const AllocateFundsV2Page = React.lazy(() => lazyRetry(() => import('./pages/AllocateFunds/AllocateFundsV2Page')));
const  PledgeMorePage= React.lazy(() => lazyRetry(() => import('./components/PledgeMorePage/PledgeMorePage')));
const AllocateFundThankyouPage = React.lazy(() => lazyRetry(() => import('./components/AllocatedFund/AllocateFundThankyouPage/AllocateFundThankyouPage')));
const PledgeMoreThankYouPage = React.lazy(()=>lazyRetry(()=>import('./components/PledgeMorePage/PledgeMoreThankYouPage/PledgeMoreThankYouPage')))
const Updates = React.lazy(() => lazyRetry(() => import('./pages/Updates')));
const SipProtectDashboard = React.lazy(() => lazyRetry(() => import('./pages/SipProtectDashboard')));
const MedBillRembDashboard = React.lazy(() => lazyRetry(() => import('./pages/MedReimbDashboard')));
const MatchingDonation = React.lazy(() => lazyRetry(() => import('./pages/MatchingDonationDashboard')));
const TeleConsultDashboard = React.lazy(() => lazyRetry(() => import('./pages/TeleConsultDashboard')));
const ReferAndEarn = React.lazy(() => lazyRetry(() => import('./pages/ReferAndEarn')));
const InactiveUser = React.lazy(() => lazyRetry(() => import('./pages/InactiveUser')));
const EditUserProfile = React.lazy(() => lazyRetry(() => import('./pages/EditUserProfile')));
const MyDonation = React.lazy(() => lazyRetry(() => import('./pages/MyDonation')));
const MyWallet = React.lazy(() => lazyRetry(() => import('./pages/MyWallet')));
const AnimalCauseDashboard = React.lazy(() => lazyRetry(() => import('./pages/AnimalCauseDashboard')));
const NonSipUser = React.lazy(() => lazyRetry(() => import('./pages/NonSipUser')));
const Explore = React.lazy(() => lazyRetry(() => import('./pages/Explore')));
// const SipSelect = React.lazy(() => lazyRetry(() => import('./pages/SipSelect')));
const SipSelectV2 = React.lazy(() => lazyRetry(() => import('./pages/SipSelectV2')));
// const SipCause = React.lazy(() => lazyRetry(() => import('./pages/SipCause')));
const EducationSipDashboard = React.lazy(() => lazyRetry(() => import('./pages/EducationSipDashboard')));
const MedicalSipDashboard = React.lazy(() => lazyRetry(() => import('./pages/MedicalSipDashboard')));
const FoodAndHunger = React.lazy(() => lazyRetry(() => import('./pages/FoodAndHunger')));
const ElderlyCause = React.lazy(() => lazyRetry(() => import('./pages/ElderlyCause')));
const Comments = React.lazy(() => lazyRetry(() => import('./pages/CommentsPage')));
const GoodDeeds = React.lazy(() => lazyRetry(() => import('./pages/GoodDeeds')));
const PitchPage = React.lazy(() => lazyRetry(() => import('./pages/PitchPage')));
const WomensCause = React.lazy(() => lazyRetry(() => import('./pages/WomensCause')));
const AcidAttackCause = React.lazy(() => lazyRetry(() => import('./pages/AcidAttackCause')));
const WidowCause = React.lazy(() => lazyRetry(() => import('./pages/WidowCause')));
const CancelSip = React.lazy(() => lazyRetry(() => import('./pages/CancelSip-v2')));
// const HealthFirstPlanPage = React.lazy(() => lazyRetry(() => import('./components/HealthFirstPlansPage')));
// const HealthFirstDashboard = React.lazy(() => lazyRetry(() => import('./pages/HealthFirstDashboard')));
const UpdatePassword = React.lazy(() => lazyRetry(() => import('./components/UpdatePassword')));
const MyPreferences = React.lazy(() => lazyRetry(() => import('./pages/Preferences')));
const DonationPreference = React.lazy(() => lazyRetry(() => import('./pages/Preferences/DonationPreference')));
const CommunicationPreference = React.lazy(() => lazyRetry(() => import('./pages/Preferences/CommunicationPreference')));
const AppDeepLinkComponent = React.lazy(() => lazyRetry(() => import('./pages/AppDeepLink')));

export const paths = [
  {
    route: '/',
    exact: true,
    component: HomeV2,
    auth: true,
  },
  {
    route: '/:cause_name',
    exact: true,
    component: HomeV2,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/mysip',
    exact: true,
    component: MySip,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/activity',
    exact: true,
    component: SipActivity,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/updates',
    exact: true,
    component: Updates,
    auth: false,
    defaultpage: true,
  },
  // {
  //   route: '/allocatefunds',
  //   exact: true,
  //   component: AllocateFunds,
  //   auth: true,
  //   defaultpage: true,
  // },
  {
    route: '/allocatefunds',
    exact: true,
    component: AllocateFundsV2Page,
    auth: true,
    defaultpage: true,
  },

   {
    route: '/pledge-more',
    exact: true,
    component: PledgeMorePage,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/allocatefunds-thankyou',
    exact: true,
    component: AllocateFundThankyouPage,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/pledge-thankyou',
    exact: true,
    component: PledgeMoreThankYouPage,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/sipprotect',
    exact: true,
    component: SipProtectDashboard,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/matchingdonation',
    exact: true,
    component: MatchingDonation,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/teleconsult',
    exact: true,
    component: TeleConsultDashboard,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/medicalreimburse',
    exact: true,
    component: MedBillRembDashboard,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/referral',
    exact: true,
    component: ReferAndEarn,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/inactiveuser',
    exact: true,
    component: InactiveUser,
    auth: true,
  },
  {
    route: '/editprofile',
    exact: true,
    component: EditUserProfile,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/mydonations',
    exact: true,
    component: MyDonation,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/nonsipuser',
    exact: true,
    component: NonSipUser,
    auth: false,
  },
  {
    route: '/explore',
    exact: true,
    component: Explore,
    auth: false,
  },
  {
    route: '/animalcause',
    exact: true,
    component: AnimalCauseDashboard,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/animalscause',
    exact: true,
    component: AnimalCauseDashboard,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/mywallet',
    exact: true,
    component: MyWallet,
    auth: true,
    defaultpage: true,
  },
  // {
  //   route: '/sip',
  //   exact: true,
  //   component: SipCause,
  //   auth: false,
  //   defaultpage: true,
  // },
  {
    route: '/sipselect',
    exact: true,
    component: SipSelectV2,
    auth: false,
    defaultpage: true,
  },
  // {
  //   route: '/sipselect',
  //   exact: true,
  //   component: SipSelect,
  //   auth: false,
  //   defaultpage: true,
  // },
  {
    route: '/educationcause',
    exact: true,
    component: EducationSipDashboard,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/elderlycause',
    exact: true,
    component: ElderlyCause,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/comments',
    exact: true,
    component: Comments,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/gooddeeds',
    exact: true,
    component: GoodDeeds,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/medicalcause',
    exact: true,
    component: MedicalSipDashboard,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/food_hungercause',
    exact: true,
    component: FoodAndHunger,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/exploresip',
    exact: true,
    component: PitchPage,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/women_girlscause',
    exact: true,
    component: WomensCause,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/acid_victimscause',
    exact: true,
    component: AcidAttackCause,
    auth: true,
    defaultpage: true
  },
  {
    route: '/cancelsip',
    exact: true,
    component: CancelSip,
    auth: true,
    defaultpage: true,
  },
  // {
  //   route: '/healthfirst',
  //   exact: true,
  //   component: HealthFirstDashboard,
  //   auth: false,
  //   defaultpage: true,
  // },
  // {
  //   route: '/healthfirstplans',
  //   exact: true,
  //   component: HealthFirstPlanPage,
  //   auth: true,
  //   defaultpage: true,
  // },
  {
    route: '/widowcause',
    exact: true,
    component: WidowCause,
    auth: true,
    defaultpage: true,
  },
  {
    route: '/updatepassword',
    exact: true,
    component: UpdatePassword,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/preferences',
    exact: true,
    component: MyPreferences,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/donationpreferences',
    exact: true,
    component: DonationPreference,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/communicationpreferences',
    exact: true,
    component: CommunicationPreference,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/hubble',
    exact: true,
    component: AppDeepLinkComponent,
    auth: false,
    defaultpage: true,
  },
  {
    route: '/billpayment',
    exact: true,
    component: AppDeepLinkComponent,
    auth: false,
    defaultpage: true,
  }
];
